
/* !!! This is code generated by Prisma. Do not edit directly. !!! */
/* eslint-disable */
// @ts-nocheck 
/**
* This file exports all enum related types from the schema.
*
* 🟢 You can import this file directly.
*/
export const GlobalRole = {
  SUPERUSER: 'SUPERUSER',
  DEPRECATED_STAFF: 'DEPRECATED_STAFF',
  SYSTEM: 'SYSTEM',
  CUSTOMER: 'CUSTOMER',
  SUPPORT: 'SUPPORT',
  REVIEWER: 'REVIEWER',
  REPORTER: 'REPORTER'
} as const

export type GlobalRole = (typeof GlobalRole)[keyof typeof GlobalRole]


export const UserType = {
  USER: 'USER',
  MACHINE: 'MACHINE'
} as const

export type UserType = (typeof UserType)[keyof typeof UserType]


export const ApiKeyType = {
  ORGANIZATION: 'ORGANIZATION',
  USER: 'USER'
} as const

export type ApiKeyType = (typeof ApiKeyType)[keyof typeof ApiKeyType]


export const SubscriptionStatus = {
  TRIAL: 'TRIAL',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
  PROSPECT: 'PROSPECT'
} as const

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus]


export const OrganizationPortalVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE',
  DISABLED: 'DISABLED'
} as const

export type OrganizationPortalVisibility = (typeof OrganizationPortalVisibility)[keyof typeof OrganizationPortalVisibility]


export const ModalStatus = {
  REDIRECTED: 'REDIRECTED',
  CANCELLED: 'CANCELLED',
  NOT_SHOWN: 'NOT_SHOWN'
} as const

export type ModalStatus = (typeof ModalStatus)[keyof typeof ModalStatus]


export const ReportVisibility = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
} as const

export type ReportVisibility = (typeof ReportVisibility)[keyof typeof ReportVisibility]


export const OrganizationRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  RESELLER: 'RESELLER'
} as const

export type OrganizationRole = (typeof OrganizationRole)[keyof typeof OrganizationRole]


export const WorkspaceRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER',
  RESELLER: 'RESELLER'
} as const

export type WorkspaceRole = (typeof WorkspaceRole)[keyof typeof WorkspaceRole]


export const AssetType = {
  URL: 'URL',
  PAGE: 'PAGE',
  ADDRESS: 'ADDRESS',
  DISCORD: 'DISCORD',
  LINKEDIN: 'LINKEDIN',
  TWITTER: 'TWITTER',
  FACEBOOK: 'FACEBOOK',
  YOUTUBE: 'YOUTUBE',
  REDDIT: 'REDDIT',
  TELEGRAM: 'TELEGRAM',
  GOOGLE_APP_STORE: 'GOOGLE_APP_STORE',
  APPLE_APP_STORE: 'APPLE_APP_STORE',
  AMAZON_APP_STORE: 'AMAZON_APP_STORE',
  MICROSOFT_APP_STORE: 'MICROSOFT_APP_STORE',
  TIKTOK: 'TIKTOK',
  INSTAGRAM: 'INSTAGRAM',
  THREADS: 'THREADS',
  MEDIUM: 'MEDIUM',
  CHROME_WEB_STORE: 'CHROME_WEB_STORE',
  MOZILLA_ADDONS: 'MOZILLA_ADDONS',
  OPERA_ADDONS: 'OPERA_ADDONS',
  EMAIL: 'EMAIL',
  PATREON: 'PATREON',
  OPENSEA: 'OPENSEA',
  FARCASTER: 'FARCASTER',
  IPFS: 'IPFS',
  GOOGLE_FORM: 'GOOGLE_FORM',
  WHATSAPP: 'WHATSAPP',
  DISCORD_USER: 'DISCORD_USER',
  QUORA: 'QUORA',
  GITHUB: 'GITHUB',
  TEACHABLE: 'TEACHABLE',
  SUBSTACK: 'SUBSTACK',
  DEBANK: 'DEBANK',
  TAWK_TO: 'TAWK_TO',
  JOTFORM: 'JOTFORM'
} as const

export type AssetType = (typeof AssetType)[keyof typeof AssetType]


export const LivenessStatus = {
  UNKNOWN: 'UNKNOWN',
  ALIVE: 'ALIVE',
  DEAD: 'DEAD'
} as const

export type LivenessStatus = (typeof LivenessStatus)[keyof typeof LivenessStatus]


export const WatchStatus = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
} as const

export type WatchStatus = (typeof WatchStatus)[keyof typeof WatchStatus]


export const WatchStatusUpdateReason = {
  DEAD: 'DEAD',
  PARKING: 'PARKING',
  TEMPLATE: 'TEMPLATE',
  CHANGED: 'CHANGED',
  DECAYED: 'DECAYED',
  ALLOWED: 'ALLOWED',
  IRRELEVANT: 'IRRELEVANT'
} as const

export type WatchStatusUpdateReason = (typeof WatchStatusUpdateReason)[keyof typeof WatchStatusUpdateReason]


export const ApiKeyEnvironment = {
  LIVE: 'LIVE',
  TEST: 'TEST'
} as const

export type ApiKeyEnvironment = (typeof ApiKeyEnvironment)[keyof typeof ApiKeyEnvironment]


export const AssetHistoryEventChangeType = {
  TITLE: 'TITLE',
  DESCRIPTION: 'DESCRIPTION',
  LIVENESS: 'LIVENESS',
  REDIRECTS: 'REDIRECTS',
  DOMAIN_STATUS: 'DOMAIN_STATUS'
} as const

export type AssetHistoryEventChangeType = (typeof AssetHistoryEventChangeType)[keyof typeof AssetHistoryEventChangeType]


export const AssetScanStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type AssetScanStatus = (typeof AssetScanStatus)[keyof typeof AssetScanStatus]


export const AssetScanEnrichmentStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
} as const

export type AssetScanEnrichmentStatus = (typeof AssetScanEnrichmentStatus)[keyof typeof AssetScanEnrichmentStatus]


export const AssetScanEnrichmentFileType = {
  SCREENSHOT: 'SCREENSHOT',
  PROFILE_IMAGE: 'PROFILE_IMAGE'
} as const

export type AssetScanEnrichmentFileType = (typeof AssetScanEnrichmentFileType)[keyof typeof AssetScanEnrichmentFileType]


export const FileProvider = {
  UPLOAD_IO: 'UPLOAD_IO',
  GOOGLE_CLOUD: 'GOOGLE_CLOUD'
} as const

export type FileProvider = (typeof FileProvider)[keyof typeof FileProvider]


export const AssetScanRelationType = {
  LINKS_TO: 'LINKS_TO',
  REDIRECTS_TO: 'REDIRECTS_TO'
} as const

export type AssetScanRelationType = (typeof AssetScanRelationType)[keyof typeof AssetScanRelationType]


export const TakedownStatus = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED'
} as const

export type TakedownStatus = (typeof TakedownStatus)[keyof typeof TakedownStatus]


export const TakedownEventType = {
  STATUS_CHANGE: 'STATUS_CHANGE',
  ASSIGNEE_CHANGE: 'ASSIGNEE_CHANGE',
  REPORT_TO_PROVIDER: 'REPORT_TO_PROVIDER',
  NOTE: 'NOTE',
  REFILED: 'REFILED',
  EMAIL_RECEIVED: 'EMAIL_RECEIVED',
  TAKEDOWN_RETRACTED: 'TAKEDOWN_RETRACTED',
  FAILED_TO_REPORT: 'FAILED_TO_REPORT',
  LIVENESS_STATUS_CHANGE: 'LIVENESS_STATUS_CHANGE'
} as const

export type TakedownEventType = (typeof TakedownEventType)[keyof typeof TakedownEventType]


export const TakedownEmailStatus = {
  SCHEDULED: 'SCHEDULED',
  SENT: 'SENT',
  CANCELLED: 'CANCELLED',
  RECEIVED: 'RECEIVED',
  FAILED: 'FAILED'
} as const

export type TakedownEmailStatus = (typeof TakedownEmailStatus)[keyof typeof TakedownEmailStatus]


export const TakedownEmailType = {
  INBOUND: 'INBOUND',
  OUTBOUND: 'OUTBOUND'
} as const

export type TakedownEmailType = (typeof TakedownEmailType)[keyof typeof TakedownEmailType]


export const OrganizationEventType = {
  REPORTING_WAVE_DONE: 'REPORTING_WAVE_DONE'
} as const

export type OrganizationEventType = (typeof OrganizationEventType)[keyof typeof OrganizationEventType]


export const ReportStatus = {
  TODO: 'TODO',
  IN_PROGRESS: 'IN_PROGRESS',
  CLOSED: 'CLOSED'
} as const

export type ReportStatus = (typeof ReportStatus)[keyof typeof ReportStatus]


export const AssetStatus = {
  UNKNOWN: 'UNKNOWN',
  ALLOWED: 'ALLOWED',
  BLOCKED: 'BLOCKED'
} as const

export type AssetStatus = (typeof AssetStatus)[keyof typeof AssetStatus]


export const ProposalReviewStatus = {
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED'
} as const

export type ProposalReviewStatus = (typeof ProposalReviewStatus)[keyof typeof ProposalReviewStatus]


export const RuleStatus = {
  ENABLED: 'ENABLED',
  EVALUATE: 'EVALUATE',
  DISABLED: 'DISABLED'
} as const

export type RuleStatus = (typeof RuleStatus)[keyof typeof RuleStatus]


export const RuleConfidence = {
  HIGH: 'HIGH',
  MEDIUM: 'MEDIUM',
  LOW: 'LOW',
  LOWEST: 'LOWEST'
} as const

export type RuleConfidence = (typeof RuleConfidence)[keyof typeof RuleConfidence]


export const CheckStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED'
} as const

export type CheckStatus = (typeof CheckStatus)[keyof typeof CheckStatus]


export const CheckConclusion = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  NEUTRAL: 'NEUTRAL',
  STARTUP_FAILURE: 'STARTUP_FAILURE',
  TIMED_OUT: 'TIMED_OUT'
} as const

export type CheckConclusion = (typeof CheckConclusion)[keyof typeof CheckConclusion]


export const ReviewDecision = {
  APPROVE: 'APPROVE',
  REJECT: 'REJECT',
  SKIP: 'SKIP',
  ESCALATE: 'ESCALATE'
} as const

export type ReviewDecision = (typeof ReviewDecision)[keyof typeof ReviewDecision]


export const DisputeSource = {
  FORM: 'FORM',
  EPD: 'EPD'
} as const

export type DisputeSource = (typeof DisputeSource)[keyof typeof DisputeSource]


export const ThreatDetectionConfigStatus = {
  ENABLED: 'ENABLED',
  EVALUATE: 'EVALUATE',
  DISABLED: 'DISABLED'
} as const

export type ThreatDetectionConfigStatus = (typeof ThreatDetectionConfigStatus)[keyof typeof ThreatDetectionConfigStatus]


export const WebhookEvent = {
  DEBUG_TEST: 'DEBUG_TEST',
  ASSET_STATUS_UPDATED: 'ASSET_STATUS_UPDATED'
} as const

export type WebhookEvent = (typeof WebhookEvent)[keyof typeof WebhookEvent]


export const WebhookDeliveryStatus = {
  PENDING: 'PENDING',
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE'
} as const

export type WebhookDeliveryStatus = (typeof WebhookDeliveryStatus)[keyof typeof WebhookDeliveryStatus]


export const SnapshotBlockType = {
  PRODUCT_UPDATE: 'PRODUCT_UPDATE',
  RECOMMENDATION: 'RECOMMENDATION'
} as const

export type SnapshotBlockType = (typeof SnapshotBlockType)[keyof typeof SnapshotBlockType]


export const ThreatSnapshotStatus = {
  NEEDS_FINALIZATION: 'NEEDS_FINALIZATION',
  IN_PROGRESS: 'IN_PROGRESS',
  FINALIZED: 'FINALIZED'
} as const

export type ThreatSnapshotStatus = (typeof ThreatSnapshotStatus)[keyof typeof ThreatSnapshotStatus]


export const ThreatSnapshotType = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY'
} as const

export type ThreatSnapshotType = (typeof ThreatSnapshotType)[keyof typeof ThreatSnapshotType]


export const ThreatSnapshotCadence = {
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  QUARTERLY: 'QUARTERLY',
  DISABLED: 'DISABLED'
} as const

export type ThreatSnapshotCadence = (typeof ThreatSnapshotCadence)[keyof typeof ThreatSnapshotCadence]


export const DiscordResponseAction = {
  REACTION: 'REACTION',
  DELETE: 'DELETE',
  NOTIFY: 'NOTIFY'
} as const

export type DiscordResponseAction = (typeof DiscordResponseAction)[keyof typeof DiscordResponseAction]


export const LivenessStatusEventType = {
  DETECTED_AS_DEAD: 'DETECTED_AS_DEAD',
  DETECTED_AS_ALIVE: 'DETECTED_AS_ALIVE',
  DETECTED_AS_UNKNOWN: 'DETECTED_AS_UNKNOWN'
} as const

export type LivenessStatusEventType = (typeof LivenessStatusEventType)[keyof typeof LivenessStatusEventType]
